export default __webpack_public_path__ + "static/media/image_icon.6b69ac9c.svg";